<div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-11 body-class">
      <h3> Gestion des périodes comptable pour la societe : <div style="display: inline;" *ngIf="societe">{{societe.code}} - {{societe.libelle}}</div></h3>
    </div>
    <div class="col-md-1 body-class" style="padding-top: 15px;">
      <button class="pull-right" color="warn" mat-raised-button type="button" (click)="onLeave()">
        <mat-icon>cancel</mat-icon> Fermer
      </button>
    </div>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: flex-start; align-items: flex-start;">
    <div class="col-md-8">
      <mat-form-field class="full-width">
        <mat-label>Année</mat-label>
        <mat-select placeholder="ANNEE (YYYY)" [formControl]="dateForm" name="annee">   
          <mat-option *ngFor="let annee of annees" (click)="search()" [value]="annee">
              {{annee}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="dateForm.hasError('required')">
          Veuillez saisir une année
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-md-1 top">
      <button mat-raised-button color="primary" type="button" (click)="search()" style="color: white;"mat-icon-button><mat-icon>search</mat-icon></button>
    </div>
  </div>  
  <div class="col-md-12">
    <div class="mat-table">
      <div class="table_principale">
        <table mat-table matSort [dataSource]="matDataSource" multiTemplateDataRows class="mat-elevation-z8" (matSortChange)="sortData($event)" matSortActive="code">
          <caption>Liste des periode SAGE</caption>
          <ng-container matColumnDef="mois">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Mois </th>
            <td mat-cell *matCellDef="let element" (click)="openModal(element)"> <div class="center">{{getMonthbyNum(element.mois)}} </div></td>
          </ng-container>
      
          <ng-container matColumnDef="date">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element" (click)="openModal(element)"> <div class="center">{{element.date | date: 'dd/MM/yyyy'}}</div> </td>
          </ng-container>
  
          <ng-container matColumnDef="statut">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Statut </th>
            <td mat-cell *matCellDef="let element" (click)="openModal(element)"> <div class="center">{{element.statut}}</div> </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns, sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
        </table> 
      </div>
    </div>
  </div>
  
